function cov_206wbv5hlu() {
  var path = "/app/src/utils/datadog/data-dog.ts";
  var hash = "2140dae4e1576fb755fa2c674c8c53bcda6eab18";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/utils/datadog/data-dog.ts",
    statementMap: {
      "0": {
        start: {
          line: 16,
          column: 33
        },
        end: {
          line: 16,
          column: 38
        }
      },
      "1": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 21,
          column: 5
        }
      },
      "2": {
        start: {
          line: 20,
          column: 6
        },
        end: {
          line: 20,
          column: 40
        }
      },
      "3": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 25,
          column: 5
        }
      },
      "4": {
        start: {
          line: 24,
          column: 6
        },
        end: {
          line: 24,
          column: 39
        }
      },
      "5": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 27,
          column: 72
        }
      },
      "6": {
        start: {
          line: 30,
          column: 39
        },
        end: {
          line: 43,
          column: 3
        }
      },
      "7": {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 68,
          column: 6
        }
      },
      "8": {
        start: {
          line: 75,
          column: 4
        },
        end: {
          line: 75,
          column: 35
        }
      },
      "9": {
        start: {
          line: 76,
          column: 4
        },
        end: {
          line: 76,
          column: 47
        }
      },
      "10": {
        start: {
          line: 77,
          column: 4
        },
        end: {
          line: 77,
          column: 50
        }
      },
      "11": {
        start: {
          line: 78,
          column: 4
        },
        end: {
          line: 80,
          column: 6
        }
      },
      "12": {
        start: {
          line: 84,
          column: 4
        },
        end: {
          line: 86,
          column: 5
        }
      },
      "13": {
        start: {
          line: 85,
          column: 6
        },
        end: {
          line: 85,
          column: 13
        }
      },
      "14": {
        start: {
          line: 88,
          column: 4
        },
        end: {
          line: 103,
          column: 5
        }
      },
      "15": {
        start: {
          line: 89,
          column: 6
        },
        end: {
          line: 99,
          column: 9
        }
      },
      "16": {
        start: {
          line: 102,
          column: 6
        },
        end: {
          line: 102,
          column: 58
        }
      },
      "17": {
        start: {
          line: 111,
          column: 16
        },
        end: {
          line: 116,
          column: 6
        }
      },
      "18": {
        start: {
          line: 118,
          column: 4
        },
        end: {
          line: 118,
          column: 27
        }
      },
      "19": {
        start: {
          line: 122,
          column: 16
        },
        end: {
          line: 127,
          column: 6
        }
      },
      "20": {
        start: {
          line: 128,
          column: 4
        },
        end: {
          line: 128,
          column: 27
        }
      },
      "21": {
        start: {
          line: 136,
          column: 16
        },
        end: {
          line: 141,
          column: 6
        }
      },
      "22": {
        start: {
          line: 142,
          column: 4
        },
        end: {
          line: 142,
          column: 27
        }
      },
      "23": {
        start: {
          line: 146,
          column: 23
        },
        end: {
          line: 148,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 18,
            column: 3
          }
        },
        loc: {
          start: {
            line: 18,
            column: 41
          },
          end: {
            line: 28,
            column: 3
          }
        },
        line: 18
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 45,
            column: 2
          },
          end: {
            line: 45,
            column: 3
          }
        },
        loc: {
          start: {
            line: 57,
            column: 18
          },
          end: {
            line: 69,
            column: 3
          }
        },
        line: 57
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 71,
            column: 2
          },
          end: {
            line: 71,
            column: 3
          }
        },
        loc: {
          start: {
            line: 74,
            column: 4
          },
          end: {
            line: 81,
            column: 3
          }
        },
        line: 74
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 83,
            column: 2
          },
          end: {
            line: 83,
            column: 3
          }
        },
        loc: {
          start: {
            line: 83,
            column: 49
          },
          end: {
            line: 104,
            column: 3
          }
        },
        line: 83
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 106,
            column: 2
          },
          end: {
            line: 106,
            column: 3
          }
        },
        loc: {
          start: {
            line: 110,
            column: 4
          },
          end: {
            line: 119,
            column: 3
          }
        },
        line: 110
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 121,
            column: 2
          },
          end: {
            line: 121,
            column: 3
          }
        },
        loc: {
          start: {
            line: 121,
            column: 47
          },
          end: {
            line: 129,
            column: 3
          }
        },
        line: 121
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 131,
            column: 2
          },
          end: {
            line: 131,
            column: 3
          }
        },
        loc: {
          start: {
            line: 135,
            column: 4
          },
          end: {
            line: 143,
            column: 3
          }
        },
        line: 135
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 18,
            column: 16
          },
          end: {
            line: 18,
            column: 37
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 18,
            column: 36
          },
          end: {
            line: 18,
            column: 37
          }
        }],
        line: 18
      },
      "1": {
        loc: {
          start: {
            line: 19,
            column: 4
          },
          end: {
            line: 21,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 19,
            column: 4
          },
          end: {
            line: 21,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 19
      },
      "2": {
        loc: {
          start: {
            line: 23,
            column: 4
          },
          end: {
            line: 25,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 23,
            column: 4
          },
          end: {
            line: 25,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 23
      },
      "3": {
        loc: {
          start: {
            line: 84,
            column: 4
          },
          end: {
            line: 86,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 84,
            column: 4
          },
          end: {
            line: 86,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 84
      },
      "4": {
        loc: {
          start: {
            line: 147,
            column: 21
          },
          end: {
            line: 147,
            column: 55
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 147,
            column: 46
          },
          end: {
            line: 147,
            column: 49
          }
        }, {
          start: {
            line: 147,
            column: 52
          },
          end: {
            line: 147,
            column: 55
          }
        }],
        line: 147
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    b: {
      "0": [0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "2140dae4e1576fb755fa2c674c8c53bcda6eab18"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_206wbv5hlu = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_206wbv5hlu();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { getEntityId } from 'src/checkout-frame/api/get-entity-id';
import { ENV } from 'src/constants/env';
import { DATADOG_BASE_URL, DEFAULT_TAGS } from 'src/utils/datadog/constants';
import { createErrorFieldFromRawError } from 'src/utils/datadog/create-error-field-from-raw-error';
import { fetchWithRetry } from 'src/utils/fetch-with-retry';
import { v4 as uuidv4 } from 'uuid';
var DataDog = /*#__PURE__*/function () {
  function DataDog(_ref) {
    var _ref$sessionSampleRat = _ref.sessionSampleRate,
      sessionSampleRate = _ref$sessionSampleRat === void 0 ? (cov_206wbv5hlu().b[0][0]++, 0) : _ref$sessionSampleRat;
    _classCallCheck(this, DataDog);
    _defineProperty(this, "shouldLogThisSession", (cov_206wbv5hlu().s[0]++, false));
    _defineProperty(this, "globalContext", (cov_206wbv5hlu().s[6]++, {
      service: 'widget-integrations',
      source: 'browser',
      origin: 'logger',
      ddtags: DEFAULT_TAGS,
      http: {
        url: window.location.href,
        useragent: navigator.userAgent
      },
      view: {
        url: window.location.href,
        referrer: document.referrer
      }
    }));
    cov_206wbv5hlu().f[0]++;
    cov_206wbv5hlu().s[1]++;
    if (sessionSampleRate <= 0) {
      cov_206wbv5hlu().b[1][0]++;
      cov_206wbv5hlu().s[2]++;
      this.shouldLogThisSession = false;
    } else {
      cov_206wbv5hlu().b[1][1]++;
    }
    cov_206wbv5hlu().s[3]++;
    if (sessionSampleRate >= 100) {
      cov_206wbv5hlu().b[2][0]++;
      cov_206wbv5hlu().s[4]++;
      this.shouldLogThisSession = true;
    } else {
      cov_206wbv5hlu().b[2][1]++;
    }
    cov_206wbv5hlu().s[5]++;
    this.shouldLogThisSession = Math.random() * 100 < sessionSampleRate;
  }
  return _createClass(DataDog, [{
    key: "getLog",
    value: function getLog(_ref2) {
      var status = _ref2.status,
        message = _ref2.message,
        context = _ref2.context,
        error = _ref2.error,
        reason = _ref2.reason;
      cov_206wbv5hlu().f[1]++;
      cov_206wbv5hlu().s[7]++;
      return _objectSpread(_objectSpread({}, this.globalContext), {}, {
        message: message,
        date: new Date().getTime(),
        status: status,
        context: _objectSpread(_objectSpread({}, context), {}, {
          reason: reason
        }),
        error: createErrorFieldFromRawError(error)
      });
    }
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(type, experiment) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              cov_206wbv5hlu().f[2]++;
              cov_206wbv5hlu().s[8]++;
              this.globalContext.type = type;
              cov_206wbv5hlu().s[9]++;
              this.globalContext.experiment = experiment;
              cov_206wbv5hlu().s[10]++;
              this.globalContext.session = {
                id: uuidv4()
              };
              cov_206wbv5hlu().s[11]++;
              this.globalContext.usr = {
                id: getEntityId()
              };
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function init(_x, _x2) {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "send",
    value: function () {
      var _send = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(logs) {
        var _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              cov_206wbv5hlu().f[3]++;
              cov_206wbv5hlu().s[12]++;
              if (this.shouldLogThisSession) {
                _context2.n = 1;
                break;
              }
              cov_206wbv5hlu().b[3][0]++;
              cov_206wbv5hlu().s[13]++;
              return _context2.a(2);
            case 1:
              cov_206wbv5hlu().b[3][1]++;
            case 2:
              cov_206wbv5hlu().s[14]++;
              _context2.p = 3;
              cov_206wbv5hlu().s[15]++;
              _context2.n = 4;
              return fetchWithRetry({
                url: DATADOG_BASE_URL.toString(),
                options: {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify(logs),
                  keepalive: true
                }
              });
            case 4:
              _context2.n = 6;
              break;
            case 5:
              _context2.p = 5;
              _t = _context2.v;
              cov_206wbv5hlu().s[16]++;
              // eslint-disable-next-line no-console
              console.error('Error when sending the log:', _t);
            case 6:
              return _context2.a(2);
          }
        }, _callee2, this, [[3, 5]]);
      }));
      function send(_x3) {
        return _send.apply(this, arguments);
      }
      return send;
    }()
  }, {
    key: "info",
    value: function () {
      var _info = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(reason, message, context) {
        var log;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              cov_206wbv5hlu().f[4]++;
              log = (cov_206wbv5hlu().s[17]++, this.getLog({
                status: 'info',
                reason: reason,
                message: message,
                context: context
              }));
              cov_206wbv5hlu().s[18]++;
              _context3.n = 1;
              return this.send([log]);
            case 1:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function info(_x4, _x5, _x6) {
        return _info.apply(this, arguments);
      }
      return info;
    }()
  }, {
    key: "error",
    value: function () {
      var _error2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(message, _error) {
        var log;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              cov_206wbv5hlu().f[5]++;
              log = (cov_206wbv5hlu().s[19]++, this.getLog({
                status: 'error',
                reason: 'error',
                message: message,
                error: _error
              }));
              cov_206wbv5hlu().s[20]++;
              _context4.n = 1;
              return this.send([log]);
            case 1:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function error(_x7, _x8) {
        return _error2.apply(this, arguments);
      }
      return error;
    }()
  }, {
    key: "warn",
    value: function () {
      var _warn = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(reason, message, context) {
        var log;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              cov_206wbv5hlu().f[6]++;
              log = (cov_206wbv5hlu().s[21]++, this.getLog({
                status: 'warn',
                reason: reason,
                message: message,
                context: context
              }));
              cov_206wbv5hlu().s[22]++;
              _context5.n = 1;
              return this.send([log]);
            case 1:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function warn(_x9, _x0, _x1) {
        return _warn.apply(this, arguments);
      }
      return warn;
    }()
  }]);
}();
export var dataDog = (cov_206wbv5hlu().s[23]++, new DataDog({
  sessionSampleRate: String(ENV) === 'prod' ? (cov_206wbv5hlu().b[4][0]++, 0.1) : (cov_206wbv5hlu().b[4][1]++, 100)
}));